module.exports = "export default function HomePage() {\n  return <h1>Hello</h1>\n}\n"